var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:['app-store-button', _vm.storeClasses],attrs:{"href":_vm.href,"disabled":_vm.disabled,"tabindex":_vm.tabIndex},domProps:{"innerHTML":_vm._s(_vm.image)},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }